import type { CollapseProps as MantineCollapseProps } from '@mantine/core';
import { Collapse as MantineCollapse } from '@mantine/core';

import type { LockedProps } from '../types';

type CollapseProps = Omit<MantineCollapseProps, LockedProps>;

export const Collapse = (props: CollapseProps) => {
  const { transitionDuration = 200, transitionTimingFunction = 'cubic-bezier(0, 0.55, 0.45, 1)' } =
    props;

  return (
    <MantineCollapse
      {...props}
      transitionDuration={transitionDuration}
      transitionTimingFunction={transitionTimingFunction}
    />
  );
};
